import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import {
    EmployeePositionService,
    StaffPosition,
    EmployeePositionLookupForm,
    EmployeePositionMapping,
} from '../../services/employee-position.service';
import { ToastService } from '../../../shared/services/toast.service';
import {
    UserPermissionsService,
    PositionPermissionUpdate,
    PermissionSetPage,
} from '../../services/user-permissions.service';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
    selector: 'app-role-management',
    templateUrl: './role-management.component.html',
    styleUrls: ['./role-management.component.scss'],
})
export class RoleManagementComponent implements OnInit, AfterViewInit {
    tabs = [
        { label: 'Position Configuration' },
        { label: 'Permissions' },
        { label: 'Job Title Mapping' },
    ];
    tab: number = 0;

    positionMappingData: EmployeePositionMapping[];
    originalPositionMappingData: EmployeePositionMapping[];
    positionTypes: StaffPosition[];
    updateData: EmployeePositionLookupForm[];
    permissionSetData: any[];
    search: string;
    allPositionsData: any[];
    allPositionsDataOriginal: any[];
    hierarchyRoleLevels: any[];
    positionPermissionMappingUpdateData: PositionPermissionUpdate[];
    permissionSetPageModels: any[];
    searchTerms: string;
    searchFilterPositionOptions: StaffPosition[];
    selectedItem: number = -1;

    public pageSizeJobMapping = 15;
    public skipJobMapping = 0;

    constructor(
        private employeePosition: EmployeePositionService,
        private toast: ToastService,
        private permissionService: UserPermissionsService,
        public dialog: MatDialog
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {
        // Load default tab; this must be updated if tabs are re-ordered
        this.loadPositionConfiguration();
    }

    // Data Handlers
    loadPositionConfiguration() {
        this.getPositionPermissions();
        this.getPermissionSets();
        this.getHierarchyRoleLevels();
        //this.getPermissionSetPages();
    }

    loadJobMapping() {
        this.getPositionMappingData();
        this.getPositions();
    }

    unloadPositionConfiguration() {
        this.allPositionsData = null;
        this.allPositionsDataOriginal = null;
        this.permissionSetData = null;
    }

    unloadJobMapping() {
        this.originalPositionMappingData = null;
        this.positionMappingData = null;
        this.searchTerms = null;
    }

    // Data
    getPositionMappingData() {
        this.employeePosition.getEmployeePositionMapping().subscribe((data) => {
            if (data) {
                data.forEach((p) => {
                    if (!p.staffPositionKey) {
                        p.staffPositionKey = 10;
                    }
                });

                this.originalPositionMappingData = data;
                this.positionMappingData = this.originalPositionMappingData;
            }
        });
    }

    getPositions() {
        this.employeePosition.getPositions().subscribe((data) => {
            if (data) {
                this.positionTypes = data;

                this.searchFilterPositionOptions = [];

                this.searchFilterPositionOptions.push({
                    staffPositionKey: -1,
                    position: 'All',
                    class: 'All',
                    category: 'All',
                });

                this.searchFilterPositionOptions.push(...this.positionTypes);
            }
        });
    }

    getPositionPermissions() {
        this.permissionService.getPositionPermissionSets().subscribe((data) => {
            if (data) {
                this.allPositionsData = data;

                this.allPositionsData.forEach((x) => {
                    if (x.homePageKey == null) {
                        x.homePageKey = 0;
                    }
                });

                this.allPositionsDataOriginal = JSON.parse(JSON.stringify(data));

                this.allPositionsData.forEach((d) => {
                    if (!d.roleName || d.roleName.length < 1) {
                        d.roleName = 'Employee';
                    }
                });

                this.getPermissionSetPages();
            }
        });
    }

    getPermissionSets() {
        this.permissionService.getPermissionSets().subscribe((data) => {
            if (data) {
                this.permissionSetData = data;
            }
        });
    }

    getHierarchyRoleLevels() {
        this.employeePosition.getHierarchyLevels().subscribe((data) => {
            if (data) {
                this.hierarchyRoleLevels = data.filter((d) => d.isActive === true);
                this.hierarchyRoleLevels.sort((a, b) => a.roleOrder - b.roleOrder);
            }
        });
    }

    getPermissionSetPages() {
        this.permissionService.getHomePages(0).subscribe((res) => {
            this.permissionSetPageModels = res;

            this.permissionSetPageModels.forEach((x) => {
                x.pages.forEach((y) => {
                    y.module = y.module.charAt(0).toUpperCase() + y.module.slice(1);
                });
            });

            this.getHomePagesByPermission();
        });
    }
    // End Data

    getHomePagesByPermission(positionModel?: any) {
        if (!positionModel) {
            // Handle initial load

            if (this.permissionSetPageModels) {
                this.allPositionsData.forEach((x) => {
                    if (x.permissionSetKey != null && x.permissionSetKey != 0) {
                        let permissions = this.permissionSetPageModels.find(
                            (y) => y.permissionSetKey == x.permissionSetKey
                        );

                        if (permissions) {
                            x.permissionSetPages = permissions.pages;
                        } else {
                            x.homePageKey = 0;
                        }

                        let pageAvailabeInPermission = permissions.pages.find(
                            (page) => page.applicationPageKey == x.homePageKey
                        );

                        if (!pageAvailabeInPermission && x.homePageKey != 0) {
                            x.homePageKey = 0;
                        }
                    } else {
                        x.homePageKey = 0;
                    }
                });
            }
        } else {
            // Handle single position change
            if (positionModel.permissionSetKey != null && positionModel.permissionSetKey != 0) {
                let permissions = this.permissionSetPageModels.find(
                    (y) => y.permissionSetKey == positionModel.permissionSetKey
                );

                if (permissions) {
                    positionModel.permissionSetPages = permissions.pages;
                } else {
                    positionModel.homePageKey = 0;
                }

                let pageAvailabeInPermission = permissions.pages.find(
                    (page) => page.applicationPageKey == positionModel.homePageKey
                );

                if (!pageAvailabeInPermission && positionModel.homePageKey != 0) {
                    positionModel.homePageKey = 0;
                }
            } else {
                positionModel.homePageKey = 0;
            }
        }
    }

    updatePositionPermissionMapping(position) {
        if (!this.positionPermissionMappingUpdateData) {
            this.positionPermissionMappingUpdateData = [];
        }

        let updateModel: PositionPermissionUpdate = {
            permissionSetKey: position.permissionSetKey.toString(),
            staffPositionKey: position.staffPositionKey,
            roleName: position.roleName,
            isActive: true,
            homePageKey: position.homePageKey,
        };

        let existingItem = this.positionPermissionMappingUpdateData.find(
            (p) => p.staffPositionKey === position.staffPositionKey
        );

        if (existingItem) {
            let itemIndex = this.positionPermissionMappingUpdateData.indexOf(existingItem);
            this.positionPermissionMappingUpdateData.splice(itemIndex, 1);
        }

        this.getHomePagesByPermission(position);

        this.positionPermissionMappingUpdateData.push(updateModel);
    }

    savePositionPermissionMapping() {
        this.permissionService
            .updatePositionPermissionSets(this.positionPermissionMappingUpdateData)
            .subscribe((data) => {
                this.toast.success(`Successfully updated position defaults.`);
                this.positionPermissionMappingUpdateData = [];
                this.allPositionsDataOriginal = JSON.parse(JSON.stringify(this.allPositionsData));
            });
    }

    cancelPositionPermissionMapping() {
        this.positionPermissionMappingUpdateData = [];
        this.allPositionsData = JSON.parse(JSON.stringify(this.allPositionsDataOriginal));
        this.getHomePagesByPermission();

        this.allPositionsData.forEach((d) => {
            if (!d.roleName || d.roleName.length < 1) {
                d.roleName = 'none';
            }
        });
    }

    handleTabChange(event: MatTabChangeEvent): void {
        this.tab = event.index;

        if (this.tab == 0) {
            this.loadPositionConfiguration();
            this.unloadJobMapping();
        } else if (this.tab == 1) {
            this.unloadJobMapping();
            this.unloadPositionConfiguration();
        } else if (this.tab == 2) {
            this.unloadPositionConfiguration();
            this.loadJobMapping();
        }
    }

    filterSearch() {
        this.positionMappingData = this.originalPositionMappingData.filter((x) =>
            x.jobTitle.toLowerCase().includes(this.searchTerms.toLowerCase())
        );
        this.selectedItem = -1;
    }

    filterPosition() {
        if (this.selectedItem == -1) {
            this.positionMappingData = this.originalPositionMappingData;
            return;
        }

        if (this.selectedItem == 0) {
            this.positionMappingData = this.originalPositionMappingData.filter(
                (x) => x.staffPositionKey == 0
            );
            return;
        }

        this.positionMappingData = this.originalPositionMappingData.filter(
            (x) => x.staffPositionKey == this.selectedItem
        );
    }

    update(job: EmployeePositionMapping) {
        let updateItem: EmployeePositionLookupForm = {
            staffPositionKey: job.staffPositionKey.toString(),
            jobTitle: job.jobTitle,
            jobCode: job.jobCode,
        };

        this.employeePosition.updateEmployeePositionMapping([updateItem]).subscribe(
            (data) => {
                this.toast.success('Job title to position mapping updated.');
                this.updateData = [];
            },
            (error) => {
                this.toast.warning('Something went wrong updating job title to position mapping.');
                throw new Error(error);
            }
        );
    }

    public pageChangeJobMapping(event: PageChangeEvent): void {
        this.skipJobMapping = event.skip;
    }

    //Deprecated with NV8236 (feature/NV-8236-PositionManagementAutoSave)
    /*autoMapJobTitleClick() {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            data: {
                title: 'Automatically Map Job Titles',
                message: `The system will attempt to map job titles to nCino Mortgage Analytics positions. You will need to review these changes before saving. Continue?`,
            },
        });

        dialogRef
            .afterClosed()
            .toPromise()
            .then((result) => {
                if (result) {
                    this.autoMapJobTitles();
                }
            });
    }*/

    /*autoMapJobTitles() {
        this.employeePosition.getAutomaticJobTitleMapping().subscribe((res) => {
            let numberMapped = 0;

            if (res && res.length !== 0) {
                res.forEach((title) => {
                    let matchingTitle = this.positionMappingData.find(
                        (x) => x.jobTitle == title.clientPosition
                    );

                    if (matchingTitle) {
                        if (matchingTitle.staffPositionKey != title.staffPositionKey) {
                            matchingTitle.staffPositionKey = title.staffPositionKey;
                            numberMapped++;
                            this.updateMapping(matchingTitle);
                        }
                    }
                });
            }

            this.toast.info(
                `${numberMapped} job titles were mapped. Please review these changes before saving.`
            );
        });
    }*/
}
